import eventFilter from './eventFilter';
import eventSetting from './eventSetting';
import addUser from './addUser';
import logSearch from './logSearch';
import eventTemplate from './eventTemplate';
import alarmGroup from "./alarmGroup";
import eventNotify from "./eventNotify";
import titleBoxWidgetConfig from "./widgets/titleBoxWidgetConfig";
import eventStausWidgetConfig from "./widgets/eventStausWidgetConfig";
import monitoringStatusWidgetConfig from "./widgets/monitoringStatusWidgetConfig";
import perfermanceTop5WidgetConfig from "./widgets/perfermanceTop5WidgetConfig";
import eventMapWidgetConfig from "./widgets/eventMapWidgetConfig";
import eventHistoryWidgetConfig from "./widgets/eventHistoryWidgetConfig";
import timeSeriesGraphWidgetConfig from "./widgets/timeSeriesGraphWidgetConfig";
import statusMetricWidgetConfig from "./widgets/statusMetricWidgetConfig";
import instanceMapWidgetConfig from "./widgets/instanceMapWidgetConfig";
import usersSetting from "./usersSetting";
import shareDashboard from "./shareDashboard";
import findTemplate from "./findTemplate";

export default {
  eventSettingAdd: eventSetting.eventSettingAdd,
  eventSettingEdit: eventSetting.eventSettingEdit,
  eventFilter,
  addUser,
  logSearch,
  eventTemplate,
  alarmGroup,
  eventNotify,
  titleBoxWidgetConfig,
  eventStausWidgetConfig,
  monitoringStatusWidgetConfig,
  perfermanceTop5WidgetConfig,
  eventMapWidgetConfig,
  eventHistoryWidgetConfig,
  timeSeriesGraphWidgetConfig,
  statusMetricWidgetConfig,
  instanceMapWidgetConfig,
  usersSetting,
  shareDashboard,
  findTemplate
};
